'use client';

import { Box, Page as PolarisPage, PageProps as PolarisPageProps } from '@shopify/polaris';
import { forwardRef } from 'react';

type PageProps = PolarisPageProps;

export const Page = forwardRef<HTMLDivElement, PageProps>(({ children, ...props }, ref) => {
  return (
    <div ref={ref}>
      <PolarisPage {...props}>
        <Box paddingBlockEnd="1200">{children}</Box>
      </PolarisPage>
    </div>
  );
});

Page.displayName = 'Page';
